<template>
  <div>

    <header class="sticky">
      <nav class="navbar navbar-expand-lg navbar-light">
        <div class="container">
          <router-link class="navbar-brand" :to="{name: 'HomePage'}" replace>
            <span class="stella-logo-text" style="font-size: 24px; text-decoration: none; cursor: pointer;">✨ stella✦</span>
          </router-link>
          <span class="float-right" v-if="!isCreatePlatform">
            <button class="btn login-btn" style="" @click="loginPage()">Login</button>
          </span>
        </div>
      </nav>
    </header>

    <section id="slide" class="cp-page py-4">
      <div class="cp-bg-orb cp-bg-orb--1"></div>
      <div class="cp-bg-orb cp-bg-orb--2"></div>

      <div class="container position-relative" style="z-index: 1;">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">
            <div class="cp-content-card p-4 p-md-5 text-center">
              
              <!-- Creator Avatar Hero -->
              <div class="avatar-glow-wrapper mb-3">
                <img v-if="!isAvatarMissing"
                     :src="imageURL"
                     class="avatar-glow-img"
                     @error="imageLoadError">
                <img v-else
                     src="@/assets/images/default_user.png"
                     class="avatar-glow-img">
                <div class="avatar-badge"><i class="fa fa-star"></i></div>
              </div>

              <h3 class="text-white font-weight-700 mb-1">Custom Request for {{ invitee.name }}</h3>
              <p class="text-white-50 font-size-14 mb-3">
                Send a personalized request directly to {{ invitee.name }}
              </p>

              <global-message></global-message>

              <form class="text-left mt-3">
                <div class="form-group mb-3">
                  <label class="text-white font-size-13 mb-2 font-weight-500">Your Message</label>
                  <textarea
                    class="form-control cp-input"
                    rows="3" 
                    placeholder="Describe what you would like..."
                    v-model="message"></textarea>
                </div>

                <div class="form-group mb-4">
                  <label class="text-white font-size-13 mb-2 font-weight-500">Select Platform</label>
                  <select
                    class="form-control cp-input" style="background-color: #1a1a1e; color: #fff;"
                    v-model="selectedPlatform">
                    <option v-for="platform in platforms" :key="platform.id" :value="platform.id" style="background-color: #1a1a1e;">
                      {{ platform.name }}
                    </option>
                  </select>
                </div>

                <button type="button"
                        class="cp-btn-primary w-100 py-3 mb-2"
                        @click="submitCustomRequest()">
                  Submit Custom Request
                </button>
                <button type="button"
                        class="cp-btn-ghost w-100 py-3"
                        @click="loginPage()">
                  Already have an account? Login
                </button>
              </form>

            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import GlobalMessage from "@/components/module/shared/GlobalMessage";
import {mapActions, mapGetters} from "vuex";
import {BASE_URL} from "@/properties/close-friend";
import CustomerMenu from "@/components/module/customer/shared/CustomerMenu";
import {customerAccountMixin} from "@/mixin/customer-account/customer-account-mixin";
import titleMixin from "@/mixin/title-mixin";
import {SERVICE_IDENTIY} from "@/properties/micro-service";
import {PwaActionBar} from "@/components/module/influencer/shared/PwaActionBar";
import LoadingModal from "@/components/module/shared/LoadingModal";

export default {
  name: 'CreateAccountExclInfluencer',
  title: 'Account creation (custom request)',
  mixins: [customerAccountMixin, titleMixin],
  components: {
    GlobalMessage, CustomerMenu, LoadingModal
  },
  data() {
    return {
      user: {},
      invitee: {},
      platforms: [],
      selectedPlatform: '',
      isCreatePlatform: false,
      message: '',
      showSlideBar: false,
    }
  },
  created() {
    this.initIGValidity();
    this.user = this.getUser;
    this.getPlatforms();
  },
  methods: {
    ...mapActions(['setUser', 'setMessage']),
    initIGValidity() {
      this.isSubmit = false;
    },
    getPlatforms() {
      this.getUnSecureData(`${SERVICE_IDENTIY}/api/v1/lookup/platforms`, (data) => {
        this.platforms = data;
      });
    },
    loginPage() {
      this.$router.push({name: 'LoginMobile'});
    },
    submitCustomRequest() {
      this.isSubmit = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      let url = `${SERVICE_IDENTIY}/api/v1/customers/${this.user.id}/custom-request/`;
      this.postData(url, {
        message: this.message,
        platformId: this.selectedPlatform,
        isPlatform: false,
        customerUrlSuffix: this.user.urlSuffix,
      }, (data) => {
        this.setMessage('REQUEST.SUBMITTED');
        this.$router.replace({name: 'SubscriptionComplete'});
      });
    }
  }
}
;
</script>